import { Button, Dropdown, Space } from 'antd';
import { driver, type Driver, type Config as DriverConfig } from 'driver.js';
import React, { useContext } from 'react';
import { useStore } from 'react-redux';
import { TbCheck, TbHelp } from 'react-icons/tb';

import { useAuth } from '~/hooks/useAuth';
import DocumentationContext from '~/hooks/DocumentationContext';

import { useAppDispatch } from '~/redux/hooks';

export default function DocumentationButton(): JSX.Element {
  const { documentation, setRunning } = useContext(DocumentationContext);
  const { user } = useAuth();

  const dispatch = useAppDispatch();
  const store = useStore();

  if (!documentation || Object.keys(documentation).length === 0) {
    return <></>;
  }

  const items = Object.entries(documentation).map(([key, value]) => {
    const config: DriverConfig & { dispatch: any; driver?: Driver; store: any; setRunning: any } = {
      ...value,
      dispatch,
      setRunning,
      store,
      doneBtnText: 'Terminer',
      nextBtnText: 'Suivant',
      prevBtnText: 'Précédent',
      progressText: '{{current}} sur {{total}}',
      showButtons: ['next', 'previous', 'close'],
    };
    return {
      icon: (
        <TbCheck
          className='anticon'
          style={{
            color: 'green',
            opacity: user?.meta?.documentationPagesSeen?.includes(key) ? 1 : 0,
          }}
        />
      ),
      key,
      label: key,
      onClick: () => {
        setRunning(true);
        dispatch({ type: 'app/documentationRunning', payload: true });

        const driverInstance = driver();
        config.driver = driverInstance;
        config.onDestroyStarted = () => {
          const target = event?.target as Element | undefined;
          if (target?.tagName === 'path') {
            if (confirm("Êtes-vous sûr de vouloir interrompre cette rubrique d'aide?")) {
              driverInstance.destroy();
            }
          } else {
            driverInstance.destroy();
          }
        };
        driverInstance.setConfig(config);
        driverInstance.drive();
      },
    };
  });

  return (
    <div className='DocumentationButton'>
      <Dropdown menu={{ items }} overlayClassName='DocumentationButton__Dropdown'>
        <Button>
          <Space>
            Aide
            <TbHelp className='anticon' />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
}
